import React, { useState, useEffect } from 'react';
import './index.css';
import OfferView from './pages/OfferView';
import GuarantorForm from './pages/GuarantorForm';
import OnboardingDashboard from './pages/OnboardingDashboard';
import BiodataForm from './pages/BiodataForm';
import PayrollForm from './pages/PayrollForm';

function Header() {
  return (
    <div style={{background:'#3B2A21',padding:'16px 24px',display:'flex',alignItems:'center',gap:12}}>
      <div style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#F2EFE7',fontWeight:600,letterSpacing:'.05em'}}>BLOANS</div>
      <div style={{color:'rgba(242,239,231,.4)',fontSize:10,letterSpacing:'.2em',textTransform:'uppercase'}}>Onboarding Portal</div>
    </div>
  );
}

function HomePage() {
  return (
    <div className="page" style={{textAlign:'center',paddingTop:60}}>
      <div style={{fontSize:48,marginBottom:16}}>🎯</div>
      <h2 style={{fontSize:'2rem',color:'#2C1F16',marginBottom:8}}>Bloans Onboarding Portal</h2>
      <p className="text-muted">Please use the link provided in your email to access your documents.</p>
    </div>
  );
}

export default function App() {
  const [page, setPage] = useState(null);
  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith('/offer/')) setPage({ type:'offer', token:path.split('/offer/')[1] });
    else if (path.startsWith('/guarantor/')) setPage({ type:'guarantor', token:path.split('/guarantor/')[1] });
    else if (path.startsWith('/onboarding/')) setPage({ type:'onboarding', token:path.split('/onboarding/')[1] });
    else if (path.startsWith('/biodata/')) setPage({ type:'biodata', token:path.split('/biodata/')[1] });
    else if (path.startsWith('/payroll/')) setPage({ type:'payroll', token:path.split('/payroll/')[1] });
    else setPage({ type:'home' });
  }, []);

  if (!page) return <div className="spinner"/>;
  return (
    <div>
      <Header />
      {page.type==='offer' && <OfferView token={page.token} />}
      {page.type==='guarantor' && <GuarantorForm token={page.token} />}
      {page.type==='onboarding' && <OnboardingDashboard token={page.token} />}
      {page.type==='biodata' && <BiodataForm token={page.token} />}
      {page.type==='payroll' && <PayrollForm token={page.token} />}
      {page.type==='home' && <HomePage />}
    </div>
  );
}
